import {Customer} from "../../data-access/api-customers/Customer";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export interface CustomerData {
  customers: Customer[];
  customerPage: number;
  customerHasNext: boolean;
  customerTotalItems: number;
  customerTotalPage: number;
  error?: unknown;
}

export type CustomerState = CustomerData;

function createInitialState(): CustomerState {
  return {
    customers: [],
    customerPage: 0,
    customerHasNext: true,
    customerTotalItems: 0,
    customerTotalPage: 0,
    error: undefined,
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'customer'
})
export class CustomerStore extends Store<CustomerState> {
  constructor() {
    super(createInitialState());
  }
}
